import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _styled from "@emotion/styled-base";
import React, { useContext, useState } from 'react';
import { useLocation } from '@reach/router';
import QueryString from 'qs';
import { PricingType } from '../common/PropTypes'; // utils

import { buildDataForPushEventStreamData, getDistanceFromTop, makeTransactionId, pushEventStreamData, pushGtmData, generateLinkWithAddedParams, generateAffiliateLink, replaceSpacesWithDashes } from '@jelly/utils'; // Import Components

import { Modal } from '../Modal';
import RfqWidget from '../RfqWidget';
import { SiteConfigContext } from '../SiteConfigProvider';
import { Button } from '@jelly/ui';
import { PhoneIcon } from '../svgs/PhoneIcon';
import { useQt } from '@jelly/utils';
var DEFAULT_AFFILIATE_TEXT = 'visit site';
var DEFAULT_WIDGET_TEXT = 'compare quotes';

var ButtonsContainer = _styled("div", {
  target: "e1q42nr00",
  label: "ButtonsContainer"
})("display:flex;flex-direction:column;align-items:center;width:100%;max-width:180px;", function (_ref) {
  var theme = _ref.theme;
  return theme.MQ.M;
}, "{align-items:flex-start;}button:not(:first-child),a:not(:first-child){margin-top:1rem;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
/**
 * This is the Monetization Button Component
 * Baked in logic to display more than one button if supplied by BE
 *
 * @param {categoryWidgetId} props.categoryWidgetId :: widget id declared on the category level
 * if this does not exist then button falls back on categoryWidgetId
 */


export var MonetizationButton = function MonetizationButton(props) {
  var buttonLimit = props.buttonLimit,
      categoryWidgetId = props.categoryWidgetId,
      _props$fallbackCompon = props.fallbackComponent,
      fallbackComponent = _props$fallbackCompon === void 0 ? null : _props$fallbackCompon,
      _props$onRfqButtonCli = props.onRfqButtonClick,
      onRfqButtonClick = _props$onRfqButtonCli === void 0 ? function () {} : _props$onRfqButtonCli,
      _props$onQtButtonClic = props.onQtButtonClick,
      onQtButtonClick = _props$onQtButtonClic === void 0 ? function () {} : _props$onQtButtonClic,
      pricing = props.pricing,
      _props$rank = props.rank,
      rank = _props$rank === void 0 ? '' : _props$rank,
      _props$sectionType = props.sectionType,
      sectionType = _props$sectionType === void 0 ? '' : _props$sectionType,
      _props$serviceName = props.serviceName,
      serviceName = _props$serviceName === void 0 ? '' : _props$serviceName,
      tabTitle = props.tabTitle,
      _props$templateType = props.templateType,
      templateType = _props$templateType === void 0 ? '' : _props$templateType,
      type = props.type;
  var affiliateLink = generateAffiliateLink(pricing);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showRfqModal = _useState2[0],
      setShowRfqModal = _useState2[1];

  var _QueryString$parse = QueryString.parse(affiliateLink === null || affiliateLink === void 0 ? void 0 : affiliateLink.split('?')[1]),
      offerId = _QueryString$parse.offer_id,
      affId = _QueryString$parse.aff_id;

  var _useQt = useQt({
    affId: affId,
    offerId: offerId
  }),
      ringpoolDefaultPhone = _useQt.ringpoolDefaultPhone,
      ringpoolId = _useQt.ringpoolId,
      isCapped = _useQt.isCapped;

  var _useContext = useContext(SiteConfigContext),
      SITE_HOST = _useContext.siteConstants.SITE_HOST;

  var routerLocation = useLocation();

  var handleCtaClick = function handleCtaClick(e, buttonType, link) {
    e.preventDefault();

    if (buttonType === 'affiliate' && !link) {
      return console.warn("Missing ".concat(serviceName, " affiliate button link"));
    }

    var bdcTransactionId = makeTransactionId();
    var bodyHeight = document.documentElement.scrollHeight;
    var buttonHeight = getDistanceFromTop(e.target);
    var buttonPosition = Math.round(buttonHeight / bodyHeight * 100);
    pushGtmData({
      event: 'click.buyButton',
      merchant: serviceName,
      placement: 'bestPickCard',
      position: "".concat(buttonPosition, "%"),
      slug: location.href,
      //eslint-disable-line
      transactionId: bdcTransactionId
    });
    pushEventStreamData(buildDataForPushEventStreamData(window.location, e.currentTarget, serviceName, buttonPosition)); // external redirect with noopener protection - https://mathiasbynens.github.io/rel-noopener/

    if (buttonType === 'affiliate') {
      var linkToOpen = "".concat(link.replace(/TX-ID-VALUE/g, bdcTransactionId));
      var newWindow = window.open();
      newWindow.opener = null;
      newWindow.location = linkToOpen;
    } else {
      setShowRfqModal(true);
    }
  };

  var setUniqueButtonId = function setUniqueButtonId(text) {
    return replaceSpacesWithDashes("".concat(templateType, "_").concat(serviceName, "_").concat(sectionType, "_").concat(text));
  };

  var widgetCategoryId = categoryWidgetId;

  if (pricing) {
    var _pricing$widget;

    if (pricing !== null && pricing !== void 0 && (_pricing$widget = pricing.widget) !== null && _pricing$widget !== void 0 && _pricing$widget.isExclusive) {
      widgetCategoryId = pricing.widget.id;
    } else {
      widgetCategoryId = categoryWidgetId || pricing.widgetId;
    }
  }

  var generateWidgetButton = function generateWidgetButton(_ref2) {
    var _ref2$buttonText = _ref2.buttonText,
        buttonText = _ref2$buttonText === void 0 ? DEFAULT_WIDGET_TEXT : _ref2$buttonText,
        _ref2$inverseButton = _ref2.inverseButton,
        inverseButton = _ref2$inverseButton === void 0 ? false : _ref2$inverseButton;

    var handleClick = function handleClick(e) {
      onRfqButtonClick();
      handleCtaClick(e, 'widget');
    };

    return /*#__PURE__*/React.createElement(Button, {
      className: "monetization-button",
      id: setUniqueButtonId(buttonText),
      onClick: handleClick,
      type: "button",
      variant: inverseButton ? 'secondary' : 'primary'
    }, buttonText);
  };

  var generateRingpoolPhoneButton = function generateRingpoolPhoneButton() {
    var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'primary';

    if (!(ringpoolDefaultPhone && ringpoolId)) {
      return null;
    }

    return /*#__PURE__*/React.createElement(Button, {
      className: "monetization-button",
      href: "tel:".concat(ringpoolDefaultPhone),
      ringpoolid: ringpoolId,
      placeholder: ringpoolDefaultPhone,
      type: "button",
      variant: variant
    }, /*#__PURE__*/React.createElement(PhoneIcon, {
      height: "20px",
      width: "20px"
    }), " \xA0", ringpoolDefaultPhone);
  };

  var generateAffiliateButton = function generateAffiliateButton(_ref3) {
    var _ref3$buttonText = _ref3.buttonText,
        buttonText = _ref3$buttonText === void 0 ? DEFAULT_AFFILIATE_TEXT : _ref3$buttonText,
        _ref3$inverseButton = _ref3.inverseButton,
        inverseButton = _ref3$inverseButton === void 0 ? false : _ref3$inverseButton,
        _ref3$isAddQtParams = _ref3.isAddQtParams,
        isAddQtParams = _ref3$isAddQtParams === void 0 ? true : _ref3$isAddQtParams,
        link = _ref3.link;

    if (isCapped) {
      return null;
    }

    var handleClick = function handleClick(e) {
      onQtButtonClick();
      handleCtaClick(e, buttonType, affiliateLinkCheck);
    };

    var buttonType = 'affiliate';
    var affiliateLinkCheck = isAddQtParams ? generateLinkWithAddedParams({
      clientLocation: "".concat(SITE_HOST).concat(routerLocation.pathname),
      link: link,
      rank: rank,
      type: type,
      tabTitle: tabTitle
    }) : link;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      className: "monetization-button",
      id: setUniqueButtonId(buttonText),
      href: affiliateLinkCheck,
      onClick: handleClick,
      rel: "sponsored nofollow noopener",
      variant: inverseButton || ringpoolDefaultPhone ? 'secondary' : 'primary'
    }, buttonText));
  };

  var generateDefaultWidgetButton = function generateDefaultWidgetButton() {
    return widgetCategoryId ? generateWidgetButton({}) : null;
  };

  var getButtonList = function getButtonList() {
    var buttonArray = [];

    var _ref4 = pricing || {},
        affiliate = _ref4.affiliate,
        selected = _ref4.selected,
        widget = _ref4.widget;

    switch (selected) {
      case 'affiliate':
        if (isCapped || !affiliate) {
          buttonArray.push(generateDefaultWidgetButton());
        } else {
          buttonArray.push(generateRingpoolPhoneButton());
          buttonArray.push(generateAffiliateButton({
            buttonText: affiliate.cta,
            link: affiliateLink,
            isAddQtParams: affiliate.isAddQtParams
          }));
        }

        break;

      case 'affiliate-widget':
        if (!affiliate) {
          buttonArray.push(generateDefaultWidgetButton());
        } else {
          buttonArray.push(generateRingpoolPhoneButton());
          buttonArray.push(generateAffiliateButton({
            buttonText: affiliate.cta,
            link: affiliateLink,
            isAddQtParams: affiliate.isAddQtParams
          }));

          if (widget) {
            buttonArray.push(generateWidgetButton({
              buttonText: widget.cta,
              inverseButton: !isCapped
            }));
          }
        }

        break;

      case 'widget':
        buttonArray.push(!widget ? generateDefaultWidgetButton() : generateWidgetButton({
          buttonText: widget.cta
        }));
        break;

      case 'widget-affiliate':
        if (!widget) {
          buttonArray.push(generateDefaultWidgetButton());
        } else {
          buttonArray.push(generateWidgetButton({
            buttonText: widget.cta
          }));
          buttonArray.push(generateRingpoolPhoneButton('secondary'));
          buttonArray.push(generateAffiliateButton({
            buttonText: affiliate.cta,
            link: affiliateLink,
            inverseButton: true,
            isAddQtParams: affiliate.isAddQtParams
          }));
        }

        break;

      default:
        buttonArray.push(generateDefaultWidgetButton());
        break;
    } // clean out all the nulls and undefined


    buttonArray = buttonArray.filter(function (item) {
      return !(item === null || item === undefined);
    }); // if there are no monetization buttons render the fallback component if there is one

    if (!buttonArray.length) {
      return fallbackComponent;
    } // if a buttonLimit was passed (like from bestpicks) trim the buttonArrray down


    if (buttonLimit) {
      buttonArray = buttonArray.slice(0, buttonLimit);
    }

    return buttonArray;
  };

  var buttonList = getButtonList();

  if (!buttonList || !buttonList.length) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    isModalVisible: showRfqModal,
    setIsModalVisible: setShowRfqModal,
    onRequestClose: function onRequestClose() {
      return setShowRfqModal(false);
    },
    closeIconPadding: '10px'
  }, /*#__PURE__*/React.createElement(RfqWidget, {
    widgetCategoryId: widgetCategoryId
  })), /*#__PURE__*/React.createElement(ButtonsContainer, null, buttonList.map(function (button, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: i
    }, " ", button, " ");
  })));
};